import { debounce } from "../../utils";

class PageNewsRecentInvestment {
    constructor() {
        const list = document.querySelector('.recent-announcements-list-wp');

        if (!list) {
            return;
        }

        this.BREAKPOINTS = {
            768: 5,
            1280: 4,
        };

        this.currentBreakpoint = this.getCurrentBreakpoint();
        this.page = 2;

        // Add a loading state
        this.isLoading = false;

        this.init();
    }

    init() {
        const debouncedResize = debounce(this.handleResize.bind(this), 250);

        $('.load-more-announcements-wp').on('click', () => {
            this.loadMoreFeaturedPosts();
        });

        $(window).on('resize', debouncedResize);

        this.resetComponent();
    }

    getCurrentBreakpoint() {
        const width = $(window).width();
        let currentBreakpoint = { size: null, items: 9 };

        for (const breakpoint in this.BREAKPOINTS) {
            if (width < breakpoint) {
                currentBreakpoint = { size: breakpoint, items: this.BREAKPOINTS[breakpoint] };
                break;
            }
        }

        return currentBreakpoint;
    }

    generateHtml(item) {
        let link = item.permalink || '';
        let className = item.class || '';
        let pattern = item.pattern || '';
        let logo = item.logo || '';
        let vertical = item.verticals || '';
        let title = item.title || '';
        let authorName = item.authors || '';
        return `
        <li>
            <a href="${link}" target="_blank" rel="noopener noreferrer">
                <div class="card ${className} p1">
                    <div class="wrap">
                        <div class="pattern">
                            ${pattern}
                        </div>
                        ${logo ? '<div class="logo"><img src="' + logo + '" alt="' + title + '"></div>' : ''}
                    </div>
                </div>

                <strong>${vertical}</strong>
                <h6>${title}</h6>
                <span>${authorName}</span>
            </a>
        </li>
        `;
    }

    resetComponent() {
        // Reset the page counter
        this.page = 1;

        // Update the current breakpoint and load the initial items
        this.currentBreakpoint = this.getCurrentBreakpoint();
        this.loadMoreFeaturedPosts(this.currentBreakpoint.items - 1, true);
    }

    loadMoreFeaturedPosts(items = this.currentBreakpoint.items, reset = false) {
        // If we are already loading, simply return a promise that immediately resolves
        if (this.isLoading) {
            return $.Deferred().resolve();
        }

        // Set loading state
        this.isLoading = true;

        // Show spinner
        $('.load-more-announcements-wp .spinner').show();

        const postType = $('.load-more-announcements-wp').data('postType');
        const tax = $('.load-more-announcements-wp').data('tax');
        const term = $('.load-more-announcements-wp').data('term');
        const field = $('.load-more-announcements-wp').data('field');
        const colors = $('.load-more-announcements-wp').data('colors');

        return $.ajax({
            type: 'post',
            dataType: 'json',
            url: wp_ajax.ajaxurl,
            data: {
                action: 'load_more_announcements',
                page: this.page,
                items,
                postType,
                tax,
                field,
                term,
                colors
            },
        })
            .done((result) => {
                if (result.status === 'success' && result.posts.length) {
                    // Clear the list only on reset
                    if (reset) {
                        $('.recent-announcements-list-wp li:not(:has(.load-more-announcements-wp))').remove();
                    }

                    let html = '';
                    result.posts.map(item => {
                        html += this.generateHtml(item);
                    });
                    $(html).insertBefore('.recent-announcements-list-wp li:last-child');
                    this.page++;

                    // If there are more posts to load, show the "load more" button
                    if (!result.isLast) {
                        $('.load-more-announcements-wp').show();
                    } else {
                        $('.load-more-announcements-wp').hide();
                    }
                } else {
                    $('.load-more-announcements-wp').hide();
                }
            })
            .fail((result) => {
                console.log(JSON.stringify(result));
            })
            // On completion of the request (whether success or failure), reset the loading state
            .always(() => {
                this.isLoading = false;
                $('.load-more-announcements-wp .spinner').hide();
            });
    }

    handleResize() {
        const newBreakpoint = this.getCurrentBreakpoint();
        if (newBreakpoint.size !== this.currentBreakpoint.size) {
            this.resetComponent();
        }
    }
}

export default PageNewsRecentInvestment;
